import React from 'react'
import { Modal } from 'react-bootstrap'

const Pageopenmodal = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      scrollable
      size="lg"
      aria-labelledby="instructions-modal-title"
      className="bl-legal"
    >
      <Modal.Header closeButton closeLabel="Close">
        <Modal.Title as="h2" id="instructions-modal-title">
          Before you continue
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <section aria-labelledby="legal-notice-heading" className="mb-4">
          <h3 id="legal-notice-heading" className="bl-legal__heading">
            <ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>
            Legal Notice
          </h3>

          <ol className="bl-legal__list">
            <li>
              The information, data, and content made available on this
              platform are provided <strong>solely for the personal use of the
              respective member</strong> to whom such information relates.
            </li>
            <li>
              All information displayed, including but not limited to
              personal details, flat-related data, area calculations,
              payment details, and society records, is <strong>confidential and proprietary</strong> in nature.
            </li>
            <li>
              No member or user is permitted to:
              <ul>
                <li>
                  Copy, reproduce, download, distribute, transmit,
                  publish, or share any data or information contained
                  herein;
                </li>
                <li>
                  Use the information for any commercial purpose or for
                  the benefit of any third party;
                </li>
                <li>
                  Publish or disclose the information on any public or
                  private platform, including social media, websites, or
                  messaging services;
                </li>
                <li>
                  Use the information for any purpose other than
                  personal reference.
                </li>
              </ul>
            </li>
            <li>
              Any <strong>unauthorized use, sharing, publication, or misuse</strong> of
              the information shall be treated as a violation of the
              Society’s rules and may attract <strong>appropriate legal action</strong> as per applicable laws.
            </li>
          </ol>
        </section>

        <section aria-labelledby="access-policy-heading" className="mb-4">
          <h3 id="access-policy-heading" className="bl-legal__heading">
            <ion-icon name="lock-closed-outline" aria-hidden="true"></ion-icon>
            Access Policy
          </h3>

          <h4 className="bl-legal__subheading">View-Only Access</h4>
          <ul className="bl-legal__list">
            <li>
              All data made available to members shall be strictly for <strong>viewing purposes only.</strong>
            </li>
            <li>
              No editing or modification rights will be provided to
              members.
            </li>
          </ul>

          <h4 className="bl-legal__subheading">Master Data &amp; Member-Specific Access</h4>
          <ul className="bl-legal__list">
            <li>
              Master table details, including <strong>area calculations, payment
              details, and other core records,</strong> shall be updated and
              managed <strong>exclusively by the Super Admin.</strong>
            </li>
            <li>
              Data related to individual flats shall be visible <strong>only to the respective member.</strong>
            </li>
            <li>
              Member-specific information will be displayed based on a{' '}
              <strong>unique Member ID,</strong> ensuring privacy and restricted access
              to each member’s own data.
            </li>
          </ul>
        </section>

        <p className="bl-legal__ack mb-0">
          By accessing and using this platform, the member
          acknowledges having read, understood, and agreed to comply
          with the terms of this Legal Notice.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-primary w-100" onClick={onClose}>
          I understand
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default Pageopenmodal
